import { get } from "lodash-es";
import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import type { Tag, TagFilterContext, TagValue } from "../models/Tag";

export const getLogTags = async (
	params?: TagFilterContext,
	signal?: AbortSignal,
): Promise<Tag[]> => {
	const apiService = new MESApiService();

	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);

	const parameters: spParameter[] = params
		? [
				{ name: "Start", value: params.startDate },
				{ name: "End", value: params.endDate ?? tomorrow },
				{
					name: "LogTypeCode",
					value: params.logTypeCode === "A" ? null : params.logTypeCode,
				},
				{
					name: "TagFilters",
					value:
						params.tagFilters.length > 0
							? JSON.stringify(params.tagFilters)
							: null,
				},
			]
		: [];

	const resp = await apiService.callV2(
		"[SYSTEM].[GetLogTags]",
		parameters,
		signal,
	);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []);
		return rows as Tag[];
	} else {
		throw new Error(resp.message || "Error fetching log tags");
	}
};

export const getLogTagValues = async (
	params?: TagFilterContext,
	signal?: AbortSignal,
): Promise<TagValue[]> => {
	const apiService = new MESApiService();

	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);

	// When getting values for a tag, exclude that tag from the filter context
	// so we show all possible values that match the OTHER filters
	const otherTagFilters = params?.tagFilters.filter(
		(f) => f.TagName !== params.tagName,
	);

	const parameters: spParameter[] = [
		{ name: "TagName", value: params?.tagName ?? "" },
		...(params
			? [
					{ name: "Start", value: params.startDate },
					{ name: "End", value: params.endDate ?? tomorrow },
					{
						name: "LogTypeCode",
						value: params.logTypeCode === "A" ? null : params.logTypeCode,
					},
					{
						name: "TagFilters",
						value:
							otherTagFilters && otherTagFilters.length > 0
								? JSON.stringify(otherTagFilters)
								: null,
					},
				]
			: []),
	];

	const resp = await apiService.callV2(
		"[SYSTEM].[GetLogTagValues]",
		parameters,
		signal,
	);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []);
		return rows as TagValue[];
	} else {
		throw new Error(resp.message || "Error fetching tag values");
	}
};
